import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
  Spinner,
} from '@monksflow/monks-ui';
import { DownloadIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export type ExportFormat = 'md' | 'docx' | 'xlsx';

interface DownloadFormatDropdownProps {
  onDownload: (format: ExportFormat) => void;
  isDownloading: boolean;
}

export const DownloadFormatDropdown = ({
  onDownload,
  isDownloading,
}: DownloadFormatDropdownProps) => {
  const { t } = useTranslation('contentTest');

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon-sm"
          disabled={isDownloading}
          aria-label={t('copyWidget.downloadFormatDropdown.downloadFormat')}
        >
          {isDownloading ? <Spinner className="size-5" /> : <DownloadIcon className="size-5" />}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-50">
        <DropdownMenuLabel className="text-muted-foreground">
          {t('copyWidget.downloadFormatDropdown.downloadFormat')}
        </DropdownMenuLabel>
        <DropdownMenuItem onClick={() => onDownload('md')}>
          {t('copyWidget.downloadFormatDropdown.md')}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => onDownload('docx')}>
          {t('copyWidget.downloadFormatDropdown.docx')}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => onDownload('xlsx')}>
          {t('copyWidget.downloadFormatDropdown.xlsx')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
